export const CLASS_MODULE_LEVELS = [
  { value: 'basic', label: 'Basic' },
  { value: 'advance', label: 'Advance' },
];

export const DEFAULT_CLASS_MODULE_LEVEL = 'basic';

export function normalizeModuleLevel(level) {
  const s = String(level ?? '').trim().toLowerCase();
  if (s === 'advance' || s === 'advanced') return 'advance';
  return DEFAULT_CLASS_MODULE_LEVEL;
}

export function moduleLevelLabel(level) {
  const value = normalizeModuleLevel(level);
  return CLASS_MODULE_LEVELS.find((o) => o.value === value)?.label || 'Basic';
}
